import { Text } from '@chakra-ui/react';

import SectionStartTemplate from '../../../templates/sectionStart';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { useTranslation } from "react-i18next";

export interface IProps {
  config: any;
}

const InterviewSectionStart = (props: IProps) => {
    const { t } = useTranslation('common');
  const { navigateBackward, navigateForward, navigateToStudentDashboard } = useCustomNavigate();

  const onPrevious = () => navigateBackward();
  const onNext = () => navigateForward();
  const onBackToTaskList = () => navigateToStudentDashboard();

  return (
    <SectionStartTemplate
      hideProgress={true}
      onNext={onNext}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
      section={props.config.SectionStart.title}
      minsToComplete={15}
    >
      <Text fontSize={'lg'}>{t('common:answerAFewQuestionsAboutYourUpco')}</Text>
    </SectionStartTemplate>
  );
};

export default InterviewSectionStart;
